import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { ClientBankAccount } from "./client-bank-account";
import { ThirdPartySource } from "../../third-parties-sources/_types/third-party-source";
import { Address } from "../../common/_types/address";
import { ClientSubtype } from "./client-subtype";

export class Client extends Resource {
    public override type = 'clients';

    @prop()
    @required()
    public clientType: string = "Person";

    @prop()
    @required()
    public name!: string;

    @prop()
    public legalName!: string;

    @prop()
    public typeOfBusiness: number = 1;
    @prop()
    public email!: string;
    @prop()
    public phone1!: string;
    @prop()
    public phone1Description!: string;
    @prop()
    public phone2!: string;
    @prop()
    public phone2Description!: string;
    @prop()
    public phone3!: string;
    @prop()
    public phone3Description!: string;
    @prop()
    public priorityPhone!: number;
    
    @prop()
    public active: boolean = true;
    @prop()
    public vatNumber!: string;

    @prop()
    public bankAccountId!: string;

    @propObject(ClientBankAccount)
    public bankAccount: ClientBankAccount = new ClientBankAccount();

    @prop()
    public addressId!: string;

    @propObject(Address)
    public address: Address = new Address();

    @prop()
    public thirdPartySourceId!: string;

    @prop()
    public thidPartySource!: ThirdPartySource;

    @prop()
    public clientSubTypeId!: string;
    
    @propObject(ClientSubtype)
    public clientSubType: ClientSubtype = new ClientSubtype();
}